import React, { Component, Fragment } from 'react';
import { Dialog, Slide, Table, TableBody, TableRow, TableCell, AppBar, Toolbar, IconButton, Typography, DialogContent,
    List, ListItem, ListItemText, ListItemSecondaryAction, Divider, ListItemAvatar, DialogTitle, Box, Tooltip, Grid,    
} from '@mui/material';
import Currency from '../common/Currency';
import { isEmpty, size } from "lodash";
import { Close, TuneRounded } from '@mui/icons-material';
import CategoriesList from '../Admin/Categories/CategoriesList';
import { CircularProgressWithLabel } from '../Admin/Budget/BudgetSingle';
import BudgetForm from '../Admin/Budget/BudgetForm';


class SubCategoriesBudget extends Component {
    state = {
        openForm: false,
        category: {},
        budget: {},
      }

    getList = () => {
        const { category, BUDGETS, CATEGORIES, CHILD, budget_year } = this.props;
        let cats = CATEGORIES.LIST[category]
        return cats.map(cat => {
            let catInfo = CHILD[cat]
            let budget = {
                budget_max : 0, 
                budget_year, 
                category_id: catInfo.category_id,
                category_parent: catInfo.category_parent,
            }

            if ( BUDGETS && BUDGETS[budget_year] && BUDGETS[budget_year][catInfo.category_id]) {
                budget = BUDGETS[budget_year][catInfo.category_id] 
            }
            let color = category ? catInfo.category_color : "#a3a0a0"
            let cat_name = category ? catInfo.category_name : ""
            // console.log('====================================');
            // console.log({budget}, BUDGETS, catInfo);
            // console.log('====================================');

            return (
                <Grid xs={12} sm={4} >
                    <Box p={2} style={{position: "relative"}} >
                        <Box style={{textAlign: "center"}} onClick={() => this.setState({ openForm: true, category: catInfo, budget })}>

                            <Tooltip arrow placement="top" title={cat_name}>
                                <Typography variant="subtitle1" component="h6" noWrap>
                                    {cat_name}
                                </Typography>
                            </Tooltip>

                            <CircularProgressWithLabel
                                color={color} 
                                spent={catInfo.budget_spent} 
                                max={budget.budget_max} 
                                value={catInfo.budget_spent*100/budget.budget_max} 
                            />
                        </Box>
                        
                        {/* <Box style={{textAlign: "right", position: "absolute", bottom: "1px", right: "1px"}}>
                            <Tooltip arrow placement="bottom" title="Modifier le budget">
                                <IconButton onClick={() => this.setState({openForm: true})} color="secondary">
                                    <TuneRounded />
                                </IconButton>
                            </Tooltip>
                        </Box> */}
                    </Box>
                </Grid>

            )
        })
    }
    render() {
        const { listSum, total } = this.props;
        const { openForm, category, budget } = this.state;

        return (                
            <List>
                {openForm && 
                    <BudgetForm 
                        category={category}
                        budget={budget}
                        handleClose={() => this.setState({openForm: false})}
                    />

                }
                <ListItem 
                    button
                >
                    <ListItemText 
                        primary={
                            <Typography >
                                Dépenses totales
                            </Typography>
                        } 
                    />
                    <ListItemSecondaryAction>
                        <ListItemText secondary={<Typography color="primary" ><Currency value={total} /></Typography>} />
                    </ListItemSecondaryAction>
                </ListItem>
                <Divider />
                <Grid container spancing={2}>
                    {this.getList()}
                </Grid>
            </List>
        );
    }
}

export default SubCategoriesBudget;